const copperData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133791/assets/data-reports/price-assessments/benchmarkminerals_Graphs_and_charts_photorealistic_realistic_sh_a447c1aa-56b5-41cf-b4fe-0398f4faff45_nbjkui.png',
  brochureFile: {
    file_name: 'Benchmark Copper Forecast.pdf',
    category: 'public-documents',
    EnvKey: 'forecastBrochureCopperFilePdfID',
  },
  forecastBrochureFile: {
    file_name: 'Benchmark Copper Forecast.pdf',
    category: 'public-documents',
    EnvKey: 'forecastBrochureCopperFilePdfID',
  },
  banner: {
    title:
      'Our service includes a deep-dive on each link in the lithium supply chain including:',
    descriptions: [
      {
        items: [
          '<strong>Mine by Mine:</strong> Brine and Spodumene Analysis',
          '<strong>Plant by Plant:</strong> Lithium Carbonate & Hydroxide Analysis',
          '<strong>Battery Focus:</strong> Demand by Cathode Chemistry with market share & intensity numbers',
          '<strong>Battery Demand:</strong> Scenarios of EV, Stationary and Portable Tech',
          '<strong>Industrial vs Battery:</strong> Ceramics & Glass, Lubricants & Grease, Metallurgy, Air Treatment, Medical',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1677858463/assets/forecasts/lithium/Benchmark_Minerals_lithium_mine_flat_shades_of_yellow_and_white_1bd378f6-3e1f-4610-8990-343340814004_1_bgvzjs.png',
        alt: 'Lithium Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1677857003/assets/forecasts/lithium/Benchmark_Minerals_Charts_in_futuristics_computers_shades_of_ye_90ae876b-5ac3-4c83-81fb-0941ec3c5246_1_a6mrfq.png',
        alt: 'Lithium Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1677857004/assets/forecasts/lithium/Mask_group_uwvojb.png',
        alt: 'Lithium Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_600,c_fill/v1681489237/assets/forecasts/lithium/Benchmark_Minerals_shades_of_yellow_and_white_lo-fi_illustratio_aed18cc0-a456-4c9b-9e47-996656d1d820_1_tffau2.jpg',
      title:
        'Our full picture understanding of lithium is most prevalent in our bottom-up cost curve analysis.',
      descriptions: [
        {
          subtitle:
            'We present a "Total Cost" number for each operating mine and development project under review which also considers: Cash/Opex, Capital Charge & Taxes & Royalties.',
          items: [
            '<strong>Time Travel:</strong> Compare Cost Curves between 2019, 2020 & 2030',
            '<strong>Brine & Hard Rock:</strong> Understand the shifting relationship',
            '<strong>Plan</strong> for your future contracts, inventory or investment needs',
          ],
        },
        {
          subtitle:
            'Backed by our industry leading and IOSCO-regulated Lithium Price Assessment Data, our research team understand lithium’s nuances that will have a major impact on accurately forecasting prices.',
          items: [
            'Forecasted to 2040: <strong>Lithium Carbonate</strong>, Battery Grade Price, Global Prevailing Price',
            'Forecasted to 2040: <strong>Lithium Hydroxide</strong>, Battery Grade Price, Global Prevailing Price',
            'Forecasted to 2040: <strong>Spodumene 6%</strong>, Australia FOB, Battery Market Material',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_400,c_fill/v1681489237/assets/forecasts/lithium/Benchmark_Minerals_Futuristic_screen_displaying_tracking_analyt_abb212d0-e919-403f-84ce-6168b907c6be_1_qufp9p.jpg',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Lithium Forecast service:',
      descriptions: [
        {
          items: [
            '<strong>Online</strong> accessible downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in 3 Excel Files - Lithium Forecast, Lithium Price Forecast & Lithium Total Cost Model',
            'Implement <strong>Your</strong> Ideas: Each file is fully customisable so you can input your own assumptions',
          ],
        },
      ],
    },
  },
}
export default copperData
